exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".products-edit div > div.flex {\n  position: relative;\n  top: 10px; }\n\n@media only screen and (max-width: 768px) {\n  .products-edit .list-tabs {\n    width: 100%; } }\n\n@media only screen and (max-width: 600px) {\n  .product-detail-container {\n    width: calc(100vw - 10px);\n    padding-left: 5px;\n    padding-right: 5px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/products/edit/index.scss
// module id = 1334
// module chunks = 0